var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"file","accept":".png, .jpg, .jpeg, .gif, .bmp, .tiff, .webp"},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }